/* PDP BUY BOX — 1 ÅRS FORBRUK (pdp-buybox-year.liquid)
   Built 2026-08-13. Deferred asset, no inline JS in the section (v3 architecture).

   Model (agreed with Tobias 2026-08-13):
   - ONE-TIME: the product is a NATIVE Shopify fixed bundle. The three selectors
     (dispenser × scent × refills) resolve ONE parent variant id which is posted to
     /cart/add.js. Shopify renders the grouped component breakdown in cart + checkout.
   - SUBSCRIPTION (pre-selected): fixed-bundle parents cannot carry selling plans, so
     the subscribe path posts TWO lines instead: the Starterkit variant one-time (full
     price) + N× the subscription refill product's scent variant carrying the selected
     Appstle selling plan. N and the per-pack plan price are per refill tier, so the
     first-order total always equals the one-time bundle price; the per-pack price
     recurs on every fulfilment.
   - Both paths show the SAME price line (the parent variant's price/compare) — the
     subscription changes what renews, never what the first order costs.

   Data contract: two JSON islands rendered by the section —
     [data-year-variants]  parent-variant map (o1/o2/o3 → id, formatted prices)
     [data-year-config]    labels, option values, images, and the "sub" block:
                           starterkit ids, sub-product scent ids, per-tier plan lists
                           (plan ids + pre-formatted unit/total prices from Liquid).
   All prices are pre-formatted in the buyer's currency by Liquid — this file never
   does money math or formatting. */
(function () {
  'use strict';

  function initYearBuybox(root) {
    var vEl = root.querySelector('[data-year-variants]');
    var cEl = root.querySelector('[data-year-config]');
    if (!vEl || !cEl) return;
    var VARIANTS, CFG;
    try {
      VARIANTS = JSON.parse(vEl.textContent);
      CFG = JSON.parse(cEl.textContent);
    } catch (e) { console.warn('[pdp-year] bad data island', e); return; }

    var state = {
      dispenser: CFG.dispenserValues[0] || 'Amber',
      scent: CFG.defaultScent || (CFG.scentValues[0] || ''),
      tier: CFG.defaultTier || (CFG.tierValues[0] || ''), // [ELICO 2026-09-06] 18 refills preselected (was index 1 = 26)
      subMode: 'once'
    };

    var MAP = {};
    VARIANTS.forEach(function (v) { MAP[v.o1 + '||' + v.o2 + '||' + v.o3] = v; });

    function currentVariant() {
      return MAP[state.dispenser + '||' + state.scent + '||' + state.tier] || null;
    }
    // All cross-product/config lookups are POSITIONAL: option values are translated
    // per locale, so matching them against settings or another product's values
    // breaks outside nb. Indexes into the option value lists are locale-stable.
    function tierIdx() { return CFG.tierValues.indexOf(state.tier); }
    function dispenserIdx() { return CFG.dispenserValues.indexOf(state.dispenser); }
    function scentIdx() { return CFG.scentValues.indexOf(state.scent); }
    function tierPacks() {
      var i = tierIdx();
      return i >= 0 ? (CFG.tierPacks[i] || 0) : 0;
    }
    function tierSub() {
      var i = tierIdx();
      return (i >= 0 && CFG.sub && CFG.sub.tiers && CFG.sub.tiers[i]) || null;
    }

    // ── subscribe / one-time toggle (deo pattern: sub pre-selected when plans exist) ──
    var subCard = root.querySelector('[data-ss][data-type="sub"]');
    var onceCard = root.querySelector('[data-ss][data-type="once"]');
    var cadenceSel = root.querySelector('[data-cadence]');
    // [ELICO 2026-09-06, Tobias] One-time is preselected on the 1-year page. Previously the
    // mere presence of the subscribe card forced subMode to 'sub'. state.subMode already
    // defaults to 'once', so this line is simply removed. On the test theme the subscribe
    // card does not render at all, so both themes land on 'once' by the same code path.

    function setSubMode(mode) {
      state.subMode = mode;
      if (subCard) subCard.classList.toggle('is-selected', mode === 'sub');
      if (onceCard) onceCard.classList.toggle('is-selected', mode === 'once');
    }
    [subCard, onceCard].forEach(function (card) {
      if (!card) return;
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-cadence]')) return;
        if (card === subCard && card.classList.contains('is-disabled')) return;
        setSubMode(card.getAttribute('data-type') === 'sub' ? 'sub' : 'once');
      });
    });
    if (cadenceSel) {
      cadenceSel.addEventListener('change', function () {
        if (subCard && !subCard.classList.contains('is-disabled')) setSubMode('sub');
      });
    }

    // The cadence dropdown is rendered by Liquid from the 4pk's existing Appstle
    // group — the same plans serve every tier; the per-tier discount is a CODE.
    function selectedPlan() {
      if (state.subMode !== 'sub' || !cadenceSel || !CFG.sub || !CFG.sub.plans.length) return null;
      var id = parseInt(cadenceSel.value, 10);
      return isNaN(id) ? null : id;
    }
    function tierCode() {
      var i = tierIdx();
      var c = i >= 0 && CFG.sub && CFG.sub.codes ? CFG.sub.codes[i] : null;
      return (c && String(c).trim()) || null;
    }

    // ── swatch groups (dispenser + scent, single-select, extras pattern) ──
    // [ELICO 2026-09-06] Dropdown scent selector. The swatch binding below only knows about
    // [data-swatch] buttons, so the <select> needs its own change handler. Writes the same
    // state.scent and re-renders exactly like a swatch tap. The heading's [data-swatch-current]
    // is not rendered in dropdown mode, so the lookup is guarded.
    root.querySelectorAll('[data-scent-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        state.scent = sel.value;
        var group = sel.closest('[data-swatch-group]');
        if (group) {
          var label = group.querySelector('[data-swatch-current]');
          if (label) label.textContent = sel.value;
        }
        render();
      });
    });

    root.querySelectorAll('[data-swatch-group]').forEach(function (group) {
      var key = group.getAttribute('data-swatch-group'); // 'dispenser' | 'scent'
      group.querySelectorAll('[data-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          state[key] = sw.getAttribute('data-value');
          group.querySelectorAll('[data-swatch]').forEach(function (x) {
            x.classList.toggle('is-selected', x === sw);
          });
          var label = group.querySelector('[data-swatch-current]');
          if (label) label.textContent = sw.getAttribute('data-label') || state[key];
          var mediaId = sw.getAttribute('data-media-id');
          if (mediaId) goToMedia(mediaId);
          render();
        });
      });
    });

    // ── refill tier tiles ──
    root.querySelectorAll('[data-tiers] .tier').forEach(function (t) {
      t.addEventListener('click', function () {
        state.tier = t.getAttribute('data-tier');
        root.querySelectorAll('[data-tiers] .tier').forEach(function (x) {
          x.classList.toggle('is-active', x === t);
        });
        render();
      });
    });

    // ── price + sub card + recap + ATC state ──
    var atcBtn = root.querySelector('[data-year-atc]');
    var stickyBtn = root.querySelector('[data-sticky-atc]');

    function subAvailable() {
      return !!(CFG.sub && CFG.sub.plans.length && tierCode() && CFG.sub.skIds[dispenserIdx()] && CFG.sub.scentIds[scentIdx()]);
    }

    function render() {
      var v = currentVariant();
      var canSub = subAvailable();

      if (subCard) {
        subCard.classList.toggle('is-disabled', !canSub);
        if (!canSub && state.subMode === 'sub') setSubMode('once');
      }

      // renewal line: "{unit} per pakke, {total} per levering" from pre-formatted strings
      var renew = root.querySelector('[data-sub-renew]');
      if (renew) {
        var sub = tierSub();
        if (sub && CFG.subRenewTpl && canSub) {
          renew.textContent = CFG.subRenewTpl.replace('{unit}', sub.unit).replace('{total}', sub.total);
          renew.style.display = '';
        } else {
          renew.style.display = 'none';
        }
      }

      var priceEls = root.querySelectorAll('[data-price]');
      var compares = root.querySelectorAll('[data-compare]');
      var pill = root.querySelector('[data-save-pill]');
      var labels = root.querySelectorAll('[data-atc-label]');
      var ok = !!(v && v.available);
      if (ok) {
        priceEls.forEach(function (el) { el.textContent = v.price; });
        // [ELICO 2026-09-06] There are now THREE struck-price nodes (price line, main ATC,
        // sticky ATC), so update all of them — querySelector only ever hit the first.
        compares.forEach(function (el) {
          if (v.compare) { el.textContent = v.compare; el.style.display = 'inline'; }
          else { el.style.display = 'none'; }
        });
        if (pill) {
          var pct = tierIdx() >= 0 ? CFG.savePctByTier[tierIdx()] : null;
          if (v.compare && pct) {
            pill.textContent = CFG.savePillTpl.replace('{n}', pct);
            pill.style.display = 'inline-block';
          } else { pill.style.display = 'none'; }
        }
        labels.forEach(function (el) { el.textContent = CFG.atcText; });
      } else {
        labels.forEach(function (el) { el.textContent = CFG.unavailableText; });
      }
      [atcBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        if (ok) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled');
      });

      if (v) {
        root.dispatchEvent(new CustomEvent('elico:variant-change', {
          bubbles: true, detail: { variantId: v.id, sectionId: root.getAttribute('data-section-id') }
        }));
        // [ELICO OOS] sold-out state (ATC swap, ETA, waitlist) lives in assets/elico-oos.js
        var vidInput = root.querySelector('[data-variant-id]');
        if (vidInput) vidInput.value = String(v.id);
        document.dispatchEvent(new CustomEvent('elico:variant', {
          detail: { sectionId: root.getAttribute('data-section-id'), variantId: v.id }
        }));
      }
    }

    // ── add to cart ──
    // Subscribe path: apply the tier's subscription-only discount code FIRST
    // (/discount/CODE primes the cart cookie — the elico-sub-discount.js pattern),
    // then post Starterkit (one-time) + N× refills 4pk on the chosen selling plan.
    var adding = false;
    function postItems(routes, items) {
      return fetch(routes + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
    }
    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available || adding) return;
      var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var items, preApply = null;
      var plan = selectedPlan();
      if (state.subMode === 'sub' && subAvailable() && plan) {
        items = [
          { id: CFG.sub.skIds[dispenserIdx()], quantity: 1 },
          { id: CFG.sub.scentIds[scentIdx()], quantity: tierPacks(), selling_plan: plan }
        ];
        preApply = tierCode();
      } else {
        items = [{ id: v.id, quantity: 1 }];
      }
      adding = true;
      if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
      var start = preApply
        ? fetch(routes + 'discount/' + encodeURIComponent(preApply)).catch(function () { })
        : Promise.resolve();
      start.then(function () { return postItems(routes, items); })
        .then(function (res) {
          adding = false;
          if (atcBtn) atcBtn.removeAttribute('disabled');
          if (res.ok) openCartDrawer(routes);
          else {
            console.warn('Add to cart failed', res.d);
            alert((res.d && res.d.description) || CFG.unavailableText);
          }
        }).catch(function (err) {
          adding = false;
          if (atcBtn) atcBtn.removeAttribute('disabled');
          console.warn(err);
        });
    }
    function openCartDrawer(routes, sections) {
      // [ELICO 2026-10-08] No fixed delay: open the cart drawer as soon as the add resolved, with its
      // lines already rebuilt. Uses the `sections` HTML returned by /cart/add.js when the caller asked
      // for it (zero extra requests), else one GET of the same section. Never opens on stale lines.
      var drawer = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
      if (!drawer || typeof drawer.getCart !== 'function') { window.location.href = routes + 'cart'; return; }
      function show() {
        try {
          if (typeof drawer.openCartDrawer === 'function') drawer.openCartDrawer();
          else if (typeof drawer.open === 'function') drawer.open();
        } catch (e) { window.location.href = routes + 'cart'; }
      }
      function apply(html) {
        try {
          if (!drawer.isCartDrawerLoaded && typeof drawer.renderCartDrawer === 'function') drawer.renderCartDrawer(false);
          var box = document.createElement('div');
          box.innerHTML = html || '';
          var content = box.querySelector('[data-api-content]');
          if (content && typeof drawer.build === 'function') { drawer.build(content); return true; }
        } catch (e) {}
        return false;
      }
      if (sections && apply(sections['api-cart-items'])) { show(); return; }
      fetch(routes + 'cart?section_id=api-cart-items').then(function (r) { return r.text(); }).then(function (t) {
        if (!apply(t)) { try { drawer.getCart(); } catch (e) {} }
        show();
      }, function () { try { drawer.getCart(); } catch (e) {} show(); });
    }
    if (atcBtn) atcBtn.addEventListener('click', addToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    // ── sticky ATC visibility (bundle pattern) ──
    var sticky = root.querySelector('[data-sticky]');
    var atcWrap = root.querySelector('[data-atc-wrap]');
    if (sticky && atcWrap && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-hidden', e.isIntersecting);
      }, { threshold: 0 }).observe(atcWrap);
    }

    // ── gallery (bundle pattern: mobile horizontal snap, desktop vertical stack) ──
    var hero = root.querySelector('[data-hero]');
    var wrap = root.querySelector('.ebb__hero-wrap');
    function setActive(i) {
      root.querySelectorAll('.ebb__thumb').forEach(function (t, x) { t.classList.toggle('is-active', x === i); });
      root.querySelectorAll('.ebb__rail-thumb').forEach(function (t, x) { t.classList.toggle('is-active', x === i); });
    }
    function go(i) {
      var slides = root.querySelectorAll('.ebb__slide');
      if (!slides[i]) return;
      if (window.innerWidth >= 990 && wrap) wrap.scrollTo({ top: slides[i].offsetTop, behavior: 'smooth' });
      else if (hero) hero.scrollTo({ left: hero.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }
    function goToMedia(mediaId) {
      var slides = root.querySelectorAll('.ebb__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
      }
    }
    root.querySelectorAll('.ebb__thumb').forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    root.querySelectorAll('.ebb__rail-thumb').forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    function syncFromScroll() {
      var slides = root.querySelectorAll('.ebb__slide');
      if (!slides.length) return;
      var i;
      if (window.innerWidth >= 990 && wrap) i = Math.round(wrap.scrollTop / (wrap.clientHeight || 1));
      else if (hero) i = Math.round(hero.scrollLeft / (hero.clientWidth || 1));
      if (i >= 0 && i < slides.length) setActive(i);
    }
    if (hero) hero.addEventListener('scroll', syncFromScroll, { passive: true });
    if (wrap) wrap.addEventListener('scroll', syncFromScroll, { passive: true });

    // ── ingredients drawer (bundle pattern) ──
    var ingDrawer = root.querySelector('[data-ingredients-drawer]');
    var openBtn = root.querySelector('[data-open-ingredients]');
    if (openBtn && ingDrawer) {
      openBtn.addEventListener('click', function () {
        ingDrawer.hidden = false;
        requestAnimationFrame(function () { ingDrawer.classList.add('is-open'); });
      });
      ingDrawer.querySelectorAll('[data-close-ingredients]').forEach(function (b) {
        b.addEventListener('click', function () {
          ingDrawer.classList.remove('is-open');
          setTimeout(function () { ingDrawer.hidden = true; }, 300);
        });
      });
    }

    // init
    render();
    // [ELICO OOS 2026-08-19, revised 2026-09-05] Market-aware default dispenser.
    // 2026-09-05 (Tobias): `available` is true for a continue-selling variant even at negative
    // stock, so a PRE-ORDER dispenser used to satisfy this check and the visitor landed on
    // "Forhandsbestill". Now: if the current dispenser cannot ship today, jump to the first one
    // that CAN (inStock, market-scoped); only if none has stock do we fall back to the old
    // availability test, so a fully pre-order product still selects something buyable-ish.
    // Positional over CFG.dispenserValues, so it works in every locale.
    (function pickAvailableDispenser() {
      var cur = currentVariant();
      if (cur && cur.inStock !== false) return;
      function jump(key) {
        for (var i = 0; i < CFG.dispenserValues.length; i++) {
          var dv = CFG.dispenserValues[i];
          var cand = MAP[dv + '||' + state.scent + '||' + state.tier];
          if (cand && cand[key] !== false && dv !== state.dispenser) {
            var sw = root.querySelector('[data-swatch-group="dispenser"] [data-swatch][data-value="' + dv.replace(/"/g, '\\"') + '"]');
            if (sw) { sw.click(); } else { state.dispenser = dv; render(); }
            return true;
          }
        }
        return false;
      }
      if (jump('inStock')) return;
      if (cur && cur.available !== false) return;
      jump('available');
    })();
  }

  function boot() {
    document.querySelectorAll('[data-year-root]').forEach(initYearBuybox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
